import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const Root = styled("div")(() => ({
  padding: "0 0 50px",
}));

export const Title = styled(Typography)(({ theme }) => ({
  marginBottom: 8,
  [theme.breakpoints.up("mobile")]: {
    marginBottom: 12,
  },
  [theme.breakpoints.up("tablet")]: {
    marginBottom: 28,
    textAlign: "left",
  },
}));

export const PlaceholderTitle = styled(Typography)(() => ({
  marginBottom: 20,
}));
